import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Spacer from 'atoms/Spacer'
import TextInput from 'atoms/TextInput'
import FieldLayout from '../FieldLayout'

export default class ProposalDescriptionEditor extends Component {
  static propTypes = {
    proposal: PropTypes.object.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  handleSave = (description) => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({ description })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete({ description: null })
  }

  render() {
    const { proposal } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Description" onDelete={this.handleDelete}>
          <TextInput
            required
            maxLength={1024}
            multiline
            placeholder="Enter description..."
            defaultValue={proposal.description || ''}
            onSave={this.handleSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
